import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { stopPrint } from "redux/actions/printers/printersActions";
import { startPrint } from "redux/actions/printers/printersActions";
import { statusPrinting } from "redux/reducers/printers/printersReducer";

import { safeRemoveChild } from "helpers/safeRemoveChild";

export const usePrintQueue = () => {

  const dispatch = useDispatch();
  const { printQueue } = useSelector(({ printers }) => printers);
  const timer = 3000;

  const triggerDownload = (blobUrl, filename) => {
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    safeRemoveChild(link);
  };

  const removingAction = (id, error='') => {
    setTimeout( () => {
       dispatch(stopPrint(id, error));
    }, timer);
  };

  const downloadPDF = async (file) => {
    dispatch(startPrint(file.id));

    if (!file?.url || !file?.id) {
      console.error("Archivo inválido o URL no definida");
      removingAction(file?.id);
      return;
    }

    try {
      const response = await fetch(file.url);
      if (!response.ok) throw new Error(`HTTP Error: ${response.status} - ${response.statusText}`);

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      triggerDownload(blobUrl, `${file.fileName}_gn4p.pdf`);
      URL.revokeObjectURL(blobUrl);
      removingAction(file?.id);
    } catch (error) {

      console.error("Error al descargar el archivo:", error);
      removingAction(file?.id, statusPrinting.ERROR.status);
    } 
  };

  
  useEffect(() => {
    if (printQueue.length && !printQueue[0].printing) {
      downloadPDF(printQueue[0]);
    }
  }, [printQueue.length]);

};
